module.exports = __webpack_public_path__ + "img/logo.bbede6be.png";